import styled from '@emotion/styled';
import { useUpdateAtom } from 'jotai/utils';
import { forwardRef } from 'react';
import SearchSection from '../SearchSection';
import ColorItem from './ColorItem';
import useSearchFilter from 'components/search/hooks/useSearchFilter';
import { add_color_atom, remove_color_atom } from 'components/search/store/searchSheet';

interface Props {}

/**
 * 검색 필터 - 색상 필터
 * @component
 */
const Color = forwardRef<HTMLElement, Props>((_, ref) => {
  const { color_list } = useSearchFilter();

  const addColor = useUpdateAtom(add_color_atom);
  const removeColor = useUpdateAtom(remove_color_atom);
  const handleColorClick = (color: string, selected: boolean) => {
    selected ? removeColor(color) : addColor(color);
  };

  return (
    <SearchSection title='색상' ref={ref}>
      <SC.List>
        {color_list.map((color) => {
          return <ColorItem key={color.name} color_item={color} onColorClick={handleColorClick} />;
        })}
      </SC.List>
    </SearchSection>
  );
});

export default Color;

const SC = {
  List: styled.div`
    box-sizing: border-box;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-gap: 0px 2px;
    width: 100%;
    min-width: 0px;
  `,
};
